import React from 'react';

import { Content } from './Content.js';

export default class UnderPipePanel extends React.Component {

  render() {
    const pipeClass = (this.props.noPipes === true) ? 'nopipes' : '';
    const title = Content[this.props.page][this.props.section].title
    const body = Content[this.props.page][this.props.section].body

    return (
      <div className={`UnderPipePanel row ${this.props.section} ${pipeClass}`}>
        <div className="stroke vertical left"></div>
        <div className="stroke vertical right"></div>
        <div className="large-number">{Content[this.props.page][this.props.section].number}</div>
        <div className="main-content" data-scroll-item-once>
          <div className="col-xs-16">
            <span className="small-title">{Content[this.props.page].smallTitle}</span>
            <h2>{title}</h2>
            <p className="body">{body}</p>
          </div>
        </div>
      </div>
    );
  }

}
